import React from 'react';

const UserStatsCompact = ({ user, ratingInfo }) => {
  return (
    <div className="user-stats-compact">
      <span
        className="stat-compact"
        style={{ color: ratingInfo.color }}
        title={`Рейтинг: ${user?.rating || 0}`}
      >
        {ratingInfo.icon} {user?.rating || 0}
      </span>
      <span className="stat-compact" title={`Пройдено игр: ${user?.games_completed || 0}`}>
        🎮 {user?.games_completed || 0}
      </span>
      <span className="stat-compact" title={`Завершено челленджей: ${user?.challenges_completed || 0}`}>
        📋 {user?.challenges_completed || 0}
      </span>
    </div>
  );
};

export default UserStatsCompact;